const contactUs = {
  formTitle: 'Зв\'язатися з нами',
  submit: 'Відправити',
  mail: 'E-mail',
  name: 'Ім\'я',
  comment: 'Повідомлення',
  sendText: 'Дякую за ваше звернення!',
  toForm: 'Назад'
}
export default contactUs;